module.exports = __webpack_public_path__ + "img/ew-icon_pending.80c56373.svg";